import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAsyncPortCreate,
  fetchAsyncPortInfo
} from "./PortInfoSlice";
import "../../css/PortCreate.css";
import { useHistory } from "react-router-dom";

const PortCreate: React.FC = () => {
  const [portName, setPortName] = useState(""); 
  const [portState, setPortState] = useState(0); 
  const [portAddress, setPortAddress] = useState(""); 
  const [maxNumber, setMaxNumber] = useState(0);
  const [nowNumber, setNowNumber] = useState(0);
  const [bookingMaxNumber, setBookingMaxNumber] = useState(0);
  const [bookingNumber, setBookingNumber] = useState(0);
  const [portLat, setPortLat] = useState(0);
  const [portLng, setPortLng] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
 
  const [timeConstraint, setTimeConstraint] = useState(0); //時間制約の有無
  const [availableStartTime, setAvailableStartTime] = useState("00:00:00");
  const [availableEndTime, setAvailableEndTime] = useState("00:00:00"); 
  const [appPictures, setAppPictures] = useState("");

  const isTimeDisabled = timeConstraint === 0; 

  const navigate = useHistory();

  const dispatch = useDispatch();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // 選択されたポートIDをAPIリクエストに使用
    dispatch(
      fetchAsyncPortCreate({
        port_name: portName,
        port_state: portState,
        port_address: portAddress,
        max_number: maxNumber,
        now_number: nowNumber,
        booking_max_number: bookingMaxNumber,
        booking_number: bookingNumber,
        port_lat: portLat,
        port_lng: portLng,
        app_pictures: appPictures,
      })
    ).then(() => {
      navigate.push("/Port_info", {
        fromPortCreate: true,
        port_name: portName,
        port_state: portState,
        port_address: portAddress,
        max_number: maxNumber,
      });
    });
    // const formData = {
    //   port_state: portState,
    //   port_name: portName,
    //   port_address: portAddress,
    //   max_number: maxNumber,
    //   now_number: nowNumber,
    //   booking_max_number: bookingMaxNumber,
    //   booking_number: bookingNumber,
    //   port_lat: portLat,
    //   port_lng: portLng,
    //   app_pictures: appPictures
    // };
    // try {
    //   await dispatch(fetchAsyncPortCreate(formData)).unwrap();
    //   await dispatch(fetchAsyncPortInfo()).unwrap();
    //   navigate.push("/Port_info");
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  };

  interface Radio {
    label: string
    value: number
}
const [selected, setSelected] = useState(0);
const changeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
  const value = Number(event.target.value);
  setSelected(value);
  setPortState(value);
};
const radioButtons: Radio[] = [
  {label: "貸出可能", value: 1},
  {label: "返却可能", value: 2},
  {label: "貸出・返却可能", value: 3},
  {label: "利用不可", value: 4}
]

const radioButtonsTime: Radio[] = [
  {label: "指定なし", value: 0},
  {label: "指定あり", value: 1}
]

  return (
    <div className="p-create">
      <div className="p-create__container">
        <h1 className="p-create__title">ポート新規作成</h1>
        <div className="p-create__button"></div>
          <form className="p-create__form" onSubmit={handleSubmit}>
            <div className="p-create__box">
              <div className="p-create__box__inner p-create__box__left">
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">ポート名</h3>
                  <input
                    type="text"
                    value={portName}
                    onChange={(e) => setPortName(e.target.value)}
                    className=""
                    required
                  />
                </div>
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">住所</h3>
                  <input
                    type="textarea"
                    value={portAddress}
                    onChange={(e) => setPortAddress(e.target.value)}
                    className=""
                    required
                  />
                </div>
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">緯度</h3>
                  <input
                    type="number"
                    value={portLat}
                    onChange={(e) => setPortLat(Number(e.target.value))}
                    className=""
                    required
                  />
                </div>
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">経度</h3>
                  <input
                    type="number"
                    value={portLng}
                    onChange={(e) => setPortLng(Number(e.target.value))}
                    className=""
                    required
                  />
                </div>
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">駐車可能台数</h3>
                  <input
                    type="number"
                    value={maxNumber}
                    onChange={(e) => setMaxNumber(Number(e.target.value))}
                    className=""
                    required
                  />
                  <span className="u-white">
                    台
                  </span>
                </div>
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">ポートステータス</h3>
                  <div className="p-create__box__status p-create__box__list">
                  {radioButtons.map(radio => {
                    return (
                      <div className="p-create__box__status__radio">
                          <input className="" type="radio" 
                              value={radio.value} checked={radio.value === selected} onChange={changeValue} required/>
                          <label className="">
                              <span className="u-white">{radio.label}</span>
                          </label>
                      </div>
                    )
                  })}
                  </div>
                </div>
                {/* <div className="port_create_input_flex">
                  <p className="port_content_form ">ポート単価</p>
                  <input
                    type="text"
                    className="port_input"
                  />
                  <span className="port_content_detail">円</span>
                </div> */}

                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">画像</h3>
                  <input
                    type="text"
                    value={appPictures}
                    onChange={(e) => setAppPictures(e.target.value)}
                    className="port_input"
                  />
                  <span className=""></span>
                </div>
              </div>

              <div className="p-create__box__inner">
                {/* <div className="port_create_input_flex">
                  <p className="start_date_form  port_column">利用開始日</p>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="port_input"
                  />
                </div>
                <div className="port_create_input_flex">
                  <p className="expiry_form  port_column">利用終了日</p>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="port_input"
                  />
                </div>

                <div className="port_create_input_flex">
                  <p className="time_limit_form  port_column">時間指定</p>
                  <div className="port_input">
                    <div className="port_time">
                      {radioButtonsTime.map(radio => {
                        return (
                          <div className="">
                              <input className="form-check-input" type="radio" name="timeConstraint" 
                                  value={radio.value} checked={radio.value === timeConstraint} onChange={(e) => setTimeConstraint(Number(e.target.value))}/>
                              <label className="form-check-label">
                                  <span className="time_limit_label">{radio.label}</span>
                              </label>
                          </div>
                        )
                      })}
                    </div>
                    <div className="port_create_input_flex">
                      <p className="available_start_time_form">開始時刻</p>
                      <input
                        type="time"
                        disabled={isTimeDisabled}
                        className={
                          isTimeDisabled ? "disabled-input" : "available_start_time_input"
                        }
                        value={availableStartTime}
                        onChange={(e) => setAvailableStartTime(e.target.value)}
                      />
                    </div>
                    <div className="port_create_input_flex">
                      <p className="available_end_time_form">終了時刻</p>
                      <input
                        type="time"
                        value={availableEndTime}
                        onChange={(e) => setAvailableEndTime(e.target.value)}
                        disabled={isTimeDisabled}
                        className={
                          isTimeDisabled ? "disabled-input" : "available_end_time_input"
                        }
                      />
                    </div>
                  </div>
                </div> */}

                {/* 不要？ */}
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">予約可能台数</h3>
                  <input
                    type="number"
                    value={bookingMaxNumber}
                    onChange={(e) => setBookingMaxNumber(Number(e.target.value))}
                    className=""
                  />
                </div>
                {/* 不要？ */}
                <div className="p-create__box__flex">
                  <h3 className="p-create__box__name">予約台数</h3>
                  <input
                    type="number"
                    value={bookingNumber}
                    onChange={(e) => setBookingNumber(Number(e.target.value))}
                    className=""
                  />
                </div>

              </div>
            </div>
            <div className="p-create__submit">
              <input
                  type="submit"
                  className="p-create__submit_"
                  value="ポートを追加する"
                />
            </div>
          </form>
      </div>
    </div>
  );
};

export default PortCreate;